(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5689],{

/***/ 93291:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var _typeof = (__webpack_require__(58921)["default"]);

function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}

function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache(nodeInterop);

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 58921:
/***/ (function(module) {

function _typeof(obj) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(obj);
}

module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),

/***/ 87032:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";
var __webpack_unused_export__;


var _interopRequireDefault = __webpack_require__(14859);

var _interopRequireWildcard = __webpack_require__(93291);

__webpack_unused_export__ = true;
exports.Z = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(58527));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(78834));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(38111));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(97111));

var _objectSpread5 = _interopRequireDefault(__webpack_require__(25782));

var _react = _interopRequireWildcard(__webpack_require__(2784));

var _propTypes = _interopRequireDefault(__webpack_require__(13980));

var _classnames = _interopRequireDefault(__webpack_require__(72779));

var _reactTransitionGroup = __webpack_require__(96090);

var _utils = __webpack_require__(13418);

var _transitionStatusToCl;

var propTypes = (0, _objectSpread5.default)({}, _reactTransitionGroup.Transition.propTypes, {
  isOpen: _propTypes.default.bool,
  children: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.node), _propTypes.default.node]),
  tag: _utils.tagPropType,
  className: _propTypes.default.node,
  navbar: _propTypes.default.bool,
  cssModule: _propTypes.default.object,
  innerRef: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.string, _propTypes.default.object])
});
var defaultProps = (0, _objectSpread5.default)({}, _reactTransitionGroup.Transition.defaultProps, {
  isOpen: false,
  appear: false,
  enter: true,
  exit: true,
  tag: 'div',
  timeout: _utils.TransitionTimeouts.Collapse
});
var transitionStatusToClassHash = (_transitionStatusToCl = {}, _transitionStatusToCl[_utils.TransitionStatuses.ENTERING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.ENTERED] = 'collapse show', _transitionStatusToCl[_utils.TransitionStatuses.EXITING] = 'collapsing', _transitionStatusToCl[_utils.TransitionStatuses.EXITED] = 'collapse', _transitionStatusToCl);

function getTransitionClass(status) {
  return transitionStatusToClassHash[status] || 'collapse';
}

function getHeight(node) {
  return node.scrollHeight;
}

var Collapse =
/*#__PURE__*/
function (_Component) {
  (0, _inheritsLoose2.default)(Collapse, _Component);

  function Collapse(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.state = {
      height: null
    };
    ['onEntering', 'onEntered', 'onExit', 'onExiting', 'onExited'].forEach(function (name) {
      _this[name] = _this[name].bind((0, _assertThisInitialized2.default)(_this));
    });
    return _this;
  }

  var _proto = Collapse.prototype;

  _proto.onEntering = function onEntering(node, isAppearing) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onEntering(node, isAppearing);
  };

  _proto.onEntered = function onEntered(node, isAppearing) {
    this.setState({
      height: null
    });
    this.props.onEntered(node, isAppearing);
  };

  _proto.onExit = function onExit(node) {
    this.setState({
      height: getHeight(node)
    });
    this.props.onExit(node);
  };

  _proto.onExiting = function onExiting(node) {
    // getting this variable triggers a reflow
    var _unused = node.offsetHeight; // eslint-disable-line no-unused-vars

    this.setState({
      height: 0
    });
    this.props.onExiting(node);
  };

  _proto.onExited = function onExited(node) {
    this.setState({
      height: null
    });
    this.props.onExited(node);
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props = this.props,
        Tag = _this$props.tag,
        isOpen = _this$props.isOpen,
        className = _this$props.className,
        navbar = _this$props.navbar,
        cssModule = _this$props.cssModule,
        children = _this$props.children,
        innerRef = _this$props.innerRef,
        otherProps = (0, _objectWithoutPropertiesLoose2.default)(_this$props, ["tag", "isOpen", "className", "navbar", "cssModule", "children", "innerRef"]);
    var height = this.state.height;
    var transitionProps = (0, _utils.pick)(otherProps, _utils.TransitionPropTypeKeys);
    var childProps = (0, _utils.omit)(otherProps, _utils.TransitionPropTypeKeys);
    return _react.default.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({}, transitionProps, {
      in: isOpen,
      onEntering: this.onEntering,
      onEntered: this.onEntered,
      onExit: this.onExit,
      onExiting: this.onExiting,
      onExited: this.onExited
    }), function (status) {
      var collapseClass = getTransitionClass(status);
      var classes = (0, _utils.mapToCssModules)((0, _classnames.default)(className, collapseClass, navbar && 'navbar-collapse'), cssModule);
      var style = height === null ? null : {
        height: height
      };
      return _react.default.createElement(Tag, (0, _extends2.default)({}, childProps, {
        style: (0, _objectSpread5.default)({}, childProps.style, {}, style),
        className: classes,
        ref: _this2.props.innerRef
      }), children);
    });
  };

  return Collapse;
}(_react.Component);

Collapse.propTypes = propTypes;
Collapse.defaultProps = defaultProps;
var _default = Collapse;
exports.Z = _default;

/***/ }),

/***/ 16609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80116);
/* harmony import */ var _Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4628);
/* harmony import */ var components_utils_AppImg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(17073);






var Achievements = function(param) {
    var achievementData = param.achievementData, sectionTitle = param.sectionTitle, sectionText = param.sectionText;
    var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_3__/* .AppContext */ .Il).isMobile;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().main),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().conainer), "container"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: sectionTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: sectionText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().achieveRow),
                    children: achievementData.map(function(data) {
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().col),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().card),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().imgBox),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_AppImg__WEBPACK_IMPORTED_MODULE_4__["default"], {
                                            src: data.image,
                                            layout: "responsive",
                                            alt: data.altText,
                                            width: isMobile ? "92" : "130",
                                            height: isMobile ? "48" : "71.75"
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textBox),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                                                className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().value),
                                                children: data.value
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                                className: (_Achievements_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                                                children: data.label
                                            })
                                        ]
                                    })
                                ]
                            })
                        }, data.id);
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Achievements);


/***/ }),

/***/ 71729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ faq_Faq; }
});

// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/classnames/index.js
var classnames = __webpack_require__(72779);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ../../node_modules/reactstrap/lib/Collapse.js
var Collapse = __webpack_require__(87032);
// EXTERNAL MODULE: ./components/service-pages/common/faq/Faq.module.scss
var Faq_module = __webpack_require__(5066);
var Faq_module_default = /*#__PURE__*/__webpack_require__.n(Faq_module);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ../core/dist/icons/Plus.svg
var Plus = __webpack_require__(57692);
// EXTERNAL MODULE: ../core/dist/icons/Minus.svg
var Minus = __webpack_require__(67843);
;// CONCATENATED MODULE: ../core/dist/icons/nf_faq.svg
var _g, _g2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



function SvgNfFaq(props) {
  return /*#__PURE__*/react.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 81,
    height: 80,
    fill: "none",
    viewBox: "0 0 81 80"
  }, props), _g || (_g = /*#__PURE__*/react.createElement("g", {
    filter: "url(#nf_faq_svg__filter0_d)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M40.26 50c11.19 0 20.26-8.954 20.26-20s-9.07-20-20.26-20C29.07 10 20 18.954 20 30s9.07 20 20.26 20z"
  }))), _g2 || (_g2 = /*#__PURE__*/react.createElement("g", {
    clipPath: "url(#nf_faq_svg__clip0)"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#FFE07D",
    d: "M31.755 20.7h8.893a3.418 3.418 0 013.418 3.418v4.438a3.418 3.418 0 01-3.418 3.418h-4.469L34.04 34.42c-.634.725-1.829.276-1.829-.687v-1.758h-.456a3.418 3.418 0 01-3.418-3.418v-4.438a3.418 3.418 0 013.418-3.418z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#FFD064",
    d: "M34 34.462c-.644.662-1.789.212-1.789-.731v-1.757h-.456a3.418 3.418 0 01-3.418-3.418v-4.44a3.417 3.417 0 013.418-3.417h1.492a3.418 3.418 0 00-3.418 3.418v4.439a3.418 3.418 0 003.418 3.418h.457v1.757c0 .3.116.551.295.731z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#B3E59F",
    d: "M47.245 26.224h-8.893a3.418 3.418 0 00-3.418 3.418v4.439a3.418 3.418 0 003.418 3.418h4.468l2.14 2.444c.634.725 1.828.277 1.828-.687V37.5h.457a3.418 3.418 0 003.418-3.418v-4.439a3.418 3.418 0 00-3.418-3.418z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#95D6A4",
    d: "M39.976 37.5h-1.624a3.418 3.418 0 01-3.418-3.419v-4.439a3.418 3.418 0 013.418-3.418h1.624a3.418 3.418 0 00-3.418 3.418v4.439a3.418 3.418 0 003.418 3.418z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    d: "M50.663 32.023a.337.337 0 00.337-.337v-2.044a3.76 3.76 0 00-3.755-3.755h-2.842v-1.77a3.76 3.76 0 00-3.755-3.755H33.92a.337.337 0 100 .674h6.727a3.083 3.083 0 013.08 3.08v1.771h-5.376a3.76 3.76 0 00-3.755 3.755v3.628l-.81.926a.692.692 0 01-.78.196.692.692 0 01-.459-.661v-1.757a.337.337 0 00-.337-.337h-.456a3.084 3.084 0 01-3.081-3.081v-4.44a3.084 3.084 0 013.081-3.08h.819a.336.336 0 000-.674h-.819a3.76 3.76 0 00-3.755 3.755v4.439a3.76 3.76 0 003.755 3.755h.12v1.42c0 .58.35 1.087.894 1.292a1.371 1.371 0 001.525-.383l.31-.354a3.758 3.758 0 003.748 3.55h4.316l2.038 2.33a1.372 1.372 0 001.525.382 1.37 1.37 0 00.895-1.292v-1.42h.119a3.76 3.76 0 003.755-3.755v-1.048a.337.337 0 10-.674 0v1.048a3.084 3.084 0 01-3.081 3.081h-.456a.337.337 0 00-.337.337v1.757c0 .36-.237.578-.458.661a.69.69 0 01-.78-.196l-2.14-2.444a.335.335 0 00-.253-.115h-4.469a3.083 3.083 0 01-3.08-3.081v-4.439a3.083 3.083 0 013.08-3.081h8.893a3.084 3.084 0 013.081 3.081v2.044c0 .186.151.337.337.337z"
  }), /*#__PURE__*/react.createElement("path", {
    fill: "#000",
    d: "M41.901 29.776a.428.428 0 00-.399-.267.43.43 0 00-.399.268l-.003.007-1.562 4.103a.336.336 0 10.629.24l.307-.805h2.046l.303.804a.336.336 0 00.434.196.337.337 0 00.196-.434l-1.548-4.103-.004-.009zm-1.17 2.872l.77-2.024.764 2.024h-1.534zm-1.646-2.411a.337.337 0 100-.674h-1.674a.337.337 0 00-.337.337v4.13a.337.337 0 10.674.001v-1.768h1.204a.337.337 0 100-.674h-1.204v-1.352h1.337zm7.005-.689a2.42 2.42 0 00-2.418 2.417 2.42 2.42 0 002.417 2.418c.554 0 1.065-.188 1.473-.502l.386.386a.335.335 0 00.476 0 .336.336 0 000-.476l-.39-.39a2.41 2.41 0 00.473-1.436 2.42 2.42 0 00-2.418-2.417zm0 4.161a1.746 1.746 0 01-1.744-1.744c0-.961.782-1.743 1.743-1.743a1.745 1.745 0 011.461 2.694l-.457-.456a.336.336 0 00-.476 0 .336.336 0 000 .476l.463.463c-.282.195-.623.31-.99.31z"
  }))), _defs || (_defs = /*#__PURE__*/react.createElement("defs", null, /*#__PURE__*/react.createElement("clipPath", {
    id: "nf_faq_svg__clip0"
  }, /*#__PURE__*/react.createElement("path", {
    fill: "#fff",
    d: "M0 0h23v23H0z",
    transform: "translate(28 19)"
  })), /*#__PURE__*/react.createElement("filter", {
    id: "nf_faq_svg__filter0_d",
    width: 80.521,
    height: 80,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/react.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/react.createElement("feOffset", {
    dy: 10
  }), /*#__PURE__*/react.createElement("feGaussianBlur", {
    stdDeviation: 10
  }), /*#__PURE__*/react.createElement("feColorMatrix", {
    values: "0 0 0 0 0.803922 0 0 0 0 0.803922 0 0 0 0 0.803922 0 0 0 0.161 0"
  }), /*#__PURE__*/react.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/react.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}

/* harmony default export */ var nf_faq = (SvgNfFaq);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 7 modules
var esm = __webpack_require__(42386);
// EXTERNAL MODULE: ../../node_modules/isomorphic-dompurify/browser.js
var browser = __webpack_require__(14304);
;// CONCATENATED MODULE: ./components/service-pages/common/faq/Faq.tsx






//Icons





var Faq = function(param) {
    var faqs = param.faqs, sectionTitle = param.sectionTitle, sectionText = param.sectionText, sectionCalss = param.sectionCalss, viewAllFaqClass = param.viewAllFaqClass;
    var ref = (0,react.useState)(0), activeFaq = ref[0], setActiveFaq = ref[1];
    var ref1 = (0,react.useState)(true), isOpen = ref1[0], setIsOpen = ref1[1];
    var t = (0,esm/* useTranslation */.$G)("servicePages").t;
    var handleisOpen = function(val) {
        var currentFaqIndex = val.currentFaqIndex, isOpen = val.isOpen;
        setActiveFaq(parseInt(currentFaqIndex));
        setIsOpen(!isOpen);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((Faq_module_default()).main, sectionCalss),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: classnames_default()((Faq_module_default()).conainer, "container"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Faq_module_default()).heading,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                        children: sectionTitle
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: (Faq_module_default()).faqContainer,
                    children: faqs === null || faqs === void 0 ? void 0 : faqs.map(function(data) {
                        return data.faqQuestions.map(function(question, index) {
                            var ref;
                            /*#__PURE__*/ return (0,jsx_runtime.jsxs)("div", {
                                className: (Faq_module_default()).faqBox,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (Faq_module_default()).faqTitle,
                                        onClick: function() {
                                            return handleisOpen({
                                                currentFaqIndex: index,
                                                isOpen: activeFaq === index ? isOpen : false
                                            });
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: question.question
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (Faq_module_default()).collapseBtn,
                                                children: activeFaq === index && isOpen ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Minus/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Plus/* default */.Z, {})
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Collapse/* default */.Z, {
                                        isOpen: activeFaq === index ? isOpen : false,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (Faq_module_default()).faqDescription,
                                            children: [
                                                question.response ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    dangerouslySetInnerHTML: {
                                                        __html: (0,browser.sanitize)(question.response)
                                                    }
                                                }) : "",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                                                    className: (Faq_module_default()).subcontent,
                                                    children: (ref = question.subContent) === null || ref === void 0 ? void 0 : ref.map(function(content, index) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                                            dangerouslySetInnerHTML: {
                                                                __html: (0,browser.sanitize)(content)
                                                            }
                                                        }, index);
                                                    })
                                                })
                                            ]
                                        })
                                    })
                                ]
                            }, index);
                        });
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: classnames_default()((Faq_module_default()).viewAllFaq, viewAllFaqClass),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(nf_faq, {})
                            }),
                            t("servicePages:online-load-booking.Faq.last_section"),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "/frequently-asked-questions",
                                prefetch: false,
                                children: t("servicePages:online-load-booking.Faq.Visit_our_FAQs_Page")
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var faq_Faq = (Faq);


/***/ }),

/***/ 42326:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(63129);
/* harmony import */ var _HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var _vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70561);
/* harmony import */ var _vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4628);
/* harmony import */ var _vahak_core_dist_icons_PlaystoreBadge_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98703);
/* harmony import */ var components_utils_AppImg__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(17073);




// import "./howitworks.scss";


// Icons


var HowItWorks = function(param) {
    var howitwork = param.howitwork, sectionTitle = param.sectionTitle, sectionText = param.sectionText, tabAppNav = param.tabAppNav, tabWebNav = param.tabWebNav, onAppTabChange = param.onAppTabChange, onWebTabChange = param.onWebTabChange;
    var isMobile = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_vahak_core_dist_app_context__WEBPACK_IMPORTED_MODULE_4__/* .AppContext */ .Il).isMobile;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("mobileapp"), isActivetabBox = ref[0], setActivetabBox = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), isActiveMob = ref1[0], setActiveMob = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), isActiveWeb = ref2[0], setActiveWeb = ref2[1];
    var handleTabBox = function(event) {
        setActivetabBox(event);
    };
    var handleTabMob = function(event) {
        setActiveMob(event);
    };
    var handleTabWeb = function(event) {
        setActiveWeb(event);
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().main), "howitwork_ssection", isActivetabBox === "webapp" ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().activeWebApp) : ""),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().conainer), "container"),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().heading),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                            children: sectionTitle
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                            children: sectionText
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().howitworkWrap)),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().navWrap),
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                                className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().nav),
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: isActivetabBox === "mobileapp" ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().active) : "",
                                        onClick: function() {
                                            handleTabBox("mobileapp");
                                            onAppTabChange && onAppTabChange();
                                        },
                                        children: tabAppNav
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: isActivetabBox === "webapp" ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().active) : "",
                                        onClick: function() {
                                            handleTabBox("webapp");
                                            onWebTabChange && onWebTabChange();
                                        },
                                        children: tabWebNav
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tabBoxWrap),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tabBox), (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().mobileAppTab), isActivetabBox === "mobileapp" ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().active) : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tabRow),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().navCol),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tabNav),
                                                    children: howitwork[0].mobileApp.map(function(data) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: isActiveMob === data.id ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().active) : "",
                                                            onClick: function() {
                                                                return handleTabMob(data.id);
                                                            },
                                                            children: [
                                                                data.title,
                                                                data.btnURL ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                    href: data.btnURL,
                                                                    className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().playStoreBtn),
                                                                    openInNewTab: true,
                                                                    children: [
                                                                        " ",
                                                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_icons_PlaystoreBadge_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {}),
                                                                        " "
                                                                    ]
                                                                }) : ""
                                                            ]
                                                        }, data.id);
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().graphicsCol),
                                                children: howitwork[0].mobileApp.map(function(data) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().imgBox), isActiveMob === data.id ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().active) : "", isActiveMob === data.id ? "imgBox_".concat(data.id) : ""),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_AppImg__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                                            src: data.image,
                                                            layout: "fixed",
                                                            alt: data.altText,
                                                            width: isMobile ? "160" : "310",
                                                            height: isMobile ? "292.44" : "565.92"
                                                        })
                                                    }, data.id);
                                                })
                                            })
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tabBox), (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().webAppTab), isActivetabBox === "webapp" ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().active) : ""),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tabRow),
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().navCol),
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                                    className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().tabNav),
                                                    children: howitwork[0].webApp.map(function(data) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("li", {
                                                            className: isActiveWeb === data.id ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().active) : "",
                                                            onClick: function() {
                                                                return handleTabWeb(data.id);
                                                            },
                                                            children: [
                                                                data.title,
                                                                data.btnURL ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_vahak_core_dist_components_app_anchor_A__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                                                    href: data.btnURL,
                                                                    className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().webLink),
                                                                    children: "www.vahak.in"
                                                                }) : ""
                                                            ]
                                                        }, data.id);
                                                    })
                                                })
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().graphicsCol),
                                                children: howitwork[0].webApp.map(function(data) {
                                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().imgBox), isActiveWeb === data.id ? (_HowItWorks_module_scss__WEBPACK_IMPORTED_MODULE_7___default().active) : ""),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_utils_AppImg__WEBPACK_IMPORTED_MODULE_6__["default"], {
                                                            src: data.image,
                                                            layout: "responsive",
                                                            alt: data.altText,
                                                            width: isMobile ? "300" : "500",
                                                            height: isMobile ? "186" : "270"
                                                        })
                                                    }, data.id);
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (HowItWorks);


/***/ }),

/***/ 35778:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(72779);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _ServiceInformation_module_scss__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(94109);
/* harmony import */ var _ServiceInformation_module_scss__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_ServiceInformation_module_scss__WEBPACK_IMPORTED_MODULE_3__);




var ServiceInformation = function(param) {
    var sectionTitle = param.sectionTitle, sectionText = param.sectionText, heading = param.heading, descriptionComponent = param.descriptionComponent;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("section", {
        className: classnames__WEBPACK_IMPORTED_MODULE_2___default()((_ServiceInformation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().main)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classnames__WEBPACK_IMPORTED_MODULE_2___default()("container"),
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: (_ServiceInformation_module_scss__WEBPACK_IMPORTED_MODULE_3___default().heading),
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                        children: heading
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                        children: sectionTitle
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        children: sectionText
                    }),
                    !!descriptionComponent ? descriptionComponent : null
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (ServiceInformation);


/***/ }),

/***/ 96080:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "U": function() { return /* binding */ breadcrumbsConstants; }
/* harmony export */ });
function breadcrumbsConstants(param) {
    var mktType = param.mktType, city = param.city;
    var breadcrumbs = {
        onlineLoadBooking: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Load Booking",\n                "item": "https://www.vahak.in/online-load-booking"  \n            }\n        ]',
        onlineLorryBooking: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Truck Booking",\n                "item": "https://www.vahak.in/online-truck-booking"  \n            }\n        ]',
        growNetwork: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Grow Transport Buisness",\n                "item": "https://www.vahak.in/grow-network"  \n            }\n        ]',
        logisticsServices: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Logistics Services",\n                "item": "https://www.vahak.in/logistics-services"  \n            }\n        ]',
        fullTruckLoad: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Full Truck Load",\n                "item": "https://www.vahak.in/full-truck-load"  \n            }\n        ]',
        partTruckLoad: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Part Load Booking",\n                "item": "https://www.vahak.in/part-load-booking"  \n            }\n        ]',
        marketplace: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "'.concat(mktType, ' Marketplace",\n                "item": "https://www.vahak.in/marketplace/').concat(mktType, '/"  \n            }  \n        ]'),
        transportDirectory: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Transporters",\n                "item": "https://www.vahak.in/transporters"  \n            }\n        ]',
        transportDirectoryLocation: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "Transporters",\n                "item": "https://www.vahak.in/transporters"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 3, \n                "name": "'.concat(city, '",\n                "item": "https://www.vahak.in/transporters/').concat(city, '"  \n            }\n        ]'),
        membershipUpgrade: '[\n            {\n                "@type": "ListItem",\n                "position": 1,\n                "name": "Home",\n                "item": "https://www.vahak.in/"\n            },\n            {\n                "@type": "ListItem",\n                "position": 2,\n                "name": "Membership",\n                "item": "https://www.vahak.in/membership/upgrade"\n            }\n        ]',
        cargoInsurance: '[\n            {\n                "@type": "ListItem",\n                "position": 1,\n                "name": "Home",\n                "item": "https://www.vahak.in/"\n            },\n            {\n                "@type": "ListItem",\n                "position": 2,\n                "name": "Cargo Insurance",\n                "item": "https://www.vahak.in/vas/cargo-insurance"\n            }\n        ]',
        cityPages: '[\n            {\n                "@type": "ListItem", \n                "position": 1, \n                "name": "Home",\n                "item": "https://www.vahak.in/"  \n            },\n            {\n                "@type": "ListItem", \n                "position": 2, \n                "name": "'.concat(city, '",\n                "item": "https://www.vahak.in/city/').concat(city, '"  \n            }\n        ]')
    };
    return breadcrumbs;
}


/***/ }),

/***/ 80116:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Achievements_main__zQJMK","achieveRow":"Achievements_achieveRow__aQDuG","heading":"Achievements_heading___Wp_N","card":"Achievements_card__r99ei","imgBox":"Achievements_imgBox__Paku4","textBox":"Achievements_textBox__oxmMr","value":"Achievements_value__gDgqh","label":"Achievements_label__N5vSS","col":"Achievements_col__FnPj5"};

/***/ }),

/***/ 5066:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"Faq_main__5qqwf","heading":"Faq_heading__6bKtg","faqBox":"Faq_faqBox__MEGfT","faqTitle":"Faq_faqTitle__EP_8C","faqDescription":"Faq_faqDescription__7zzrf","viewAllFaq":"Faq_viewAllFaq__ixd1B","subcontent":"Faq_subcontent__YiNEP","collapseBtn":"Faq_collapseBtn__eWIHc"};

/***/ }),

/***/ 63129:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"HowItWorks_main__AT5Qm","howitWorksRow":"HowItWorks_howitWorksRow__hbSGh","heading":"HowItWorks_heading__Xd_Mj","howitworkWrap":"HowItWorks_howitworkWrap__yzYqh","navWrap":"HowItWorks_navWrap__qCTOY","nav":"HowItWorks_nav__Y6mnS","active":"HowItWorks_active__P4Ums","tabRow":"HowItWorks_tabRow__ijMnQ","tabNav":"HowItWorks_tabNav__ZYTEo","imgBox":"HowItWorks_imgBox__Le1Od","tabBox":"HowItWorks_tabBox__8g1hi","navCol":"HowItWorks_navCol__Z5uRH","graphicsCol":"HowItWorks_graphicsCol__XSF8I","tabBoxWrap":"HowItWorks_tabBoxWrap__4ap7b","webAppTab":"HowItWorks_webAppTab__ceibo","playStoreBtn":"HowItWorks_playStoreBtn__SzYYG","mobileAppTab":"HowItWorks_mobileAppTab__8ToUT","fadeInActiveAppTab":"HowItWorks_fadeInActiveAppTab__qfx4m","fadeInActive":"HowItWorks_fadeInActive___qpdF","fadeInActiveGraphics":"HowItWorks_fadeInActiveGraphics__c1WVC","activeWebApp":"HowItWorks_activeWebApp__Yq8ZK"};

/***/ }),

/***/ 94109:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"ServiceInformation_main__7yCKx","heading":"ServiceInformation_heading___E1GI"};

/***/ })

}]);